import React from "react"
import { NavLink } from "react-router-dom"

import BigQuote from "../../components/Site/BigQuote"
import * as Icons from "../../assets/icons"
import menu from "./Menu/data"
import Logo from "../../assets/images/logo.png"
import { phone, email, offices, hours, facebook } from "../../data/Contact"

const Footer = () => {
  const services = menu.find((item) => item.url === "/uslugi").submenu

  return (
    <footer className="footer">
      <BigQuote text={quote} />
      <div className="footer-cta">
        <div>
          <h2>Sprawdź, ile możesz zyskać</h2>
          <p>Zadzwoń lub napisz – odpowiemy na wszystkie pytania po polsku.</p>
        </div>
        <div className="footer-cta-actions">
          <a href={phone.href} className="button button-primary button-large">
            <Icons.Phone /> {phone.display}
          </a>
          <NavLink to="/kontakt" className="button button-light button-large">
            Formularz kontaktowy
          </NavLink>
        </div>
      </div>
      <div className="footer-grid">
        <div className="footer-col">
          <img src={Logo} alt="" className="footer-logo" />
          <p>
            D&M Accountancy Services – polskie biuro księgowe w Irlandii. Pomagamy przedsiębiorcom
            i pracownikom od 2008 roku.
          </p>
          <a href={facebook} target="_blank" rel="noopener noreferrer" className="footer-social">
            <Icons.Facebook /> Facebook
          </a>
        </div>
        <div className="footer-col">
          <h3>Usługi</h3>
          <ul>
            {services.map((item) => (
              <li key={item.id}>
                <NavLink to={item.url}>{item.name}</NavLink>
              </li>
            ))}
            <li>
              <NavLink to="/cennik">Cennik</NavLink>
            </li>
          </ul>
        </div>
        <div className="footer-col">
          <h3>Kontakt</h3>
          <ul className="footer-contact">
            <li>
              <Icons.Phone /> <a href={phone.href}>{phone.display}</a>
            </li>
            <li>
              <Icons.Contact /> <a href={`mailto:${email}`}>{email}</a>
            </li>
            {offices.map((office) => (
              <li key={office.city}>
                <Icons.Location />
                <address>
                  <strong>{office.city}</strong>
                  <a href={office.url} target="_blank" rel="noopener noreferrer">
                    {office.address}
                  </a>
                </address>
              </li>
            ))}
          </ul>
        </div>
        <div className="footer-col">
          <h3>Godziny otwarcia</h3>
          <table className="hours">
            <tbody>
              {hours.map(({ day, time }) => (
                <tr key={day} className={time ? "" : "closed"}>
                  <td>{day}</td>
                  <td>{time || "zamknięte"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="footer-bottom">
        © {new Date().getFullYear()} D&M Accountancy Services. Wszelkie prawa zastrzeżone.
      </div>
    </footer>
  )
}

const quote = `Powierzenie spraw księgowo-rachunkowych oraz socjalnych wyspecjalizowanej
firmie pozwoli Państwu zaoszczędzić cenny <b>czas</b>, <b>pieniądze</b> oraz
zagwarantuje finansowe <b>bezpieczeństwo</b>.`

export default Footer
